import { c as _c } from "react/compiler-runtime";
import { isApiError } from '@/shared/api';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { ErrorBoundaryProps } from '../model/types';
import ErrorFallback from './ErrorFallback';
export default function FetchErrorBoundary(t0) {
  const $ = _c(3);
  const {
    error,
    reset
  } = t0;
  if (!isApiError(error)) {
    throw error;
  }
  let t1;
  if ($[0] !== error || $[1] !== reset) {
    t1 = <QueryErrorResetBoundary>{t2 => {
        const {
          reset: resetQuery
        } = t2;
        return <ErrorFallback error={error} reset={() => {
          resetQuery();
          reset();
        }} />;
      }}</QueryErrorResetBoundary>;
    $[0] = error;
    $[1] = reset;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}